<template>
  <section :class="[{
    fontLoaded: true,
    loading
  }]">
    <div class="v-align">
      <div class="inner">
        <h2>Active Engagements</h2>

        <transition-group appear name="option-list" tag="ul">
          <li
            @click="startPollGroup(pollGroup, $event)"
            :class="[`option-list swpoll-vote item${index + 1} showanswer`]"
            :style="{ borderColor: answerBackgroundColor }"
            v-for="(pollGroup, index) in gamePollGroups" :key="pollGroup.pollGroupId"
          >
            <div v-if="pollGroup.badgeImage" class="swimg">
              <img :src="pollGroup.badgeImage" alt="">
            </div>
            <div class="text">
              <p :style="{ color: answerTextColor }">{{pollGroup.label}}</p>
            </div>
          </li>
        </transition-group>
      </div>
    </div>

    <transition name="preloader">
      <Preloader v-if="loading" />
    </transition>
    <transition name="block-5">
      <PoweredBy v-if="!loading" data-iframe-height="1" />
    </transition>
  </section>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState,
  mapGetters
} from 'vuex';

import Preloader from './Preloader';
import PoweredBy from './PoweredBy.vue';

export default {
  name: 'PollGroups',
  components: {
    Preloader,
    PoweredBy
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('poll', [
      'fontLoaded',
      'answerTextColor',
      'answerBackgroundColor',
    ]),
    ...mapState('voter', [
      'gamePollGroups',
      'isAuthenticated'
    ]),
    ...mapGetters('voter', [
      'isAuthenticationEnabled'
    ]),
  },
  methods: {
    ...mapActions('voter', ['switchView']),
    startPollGroup(group) {
      this.switchView('poll');
      this.loading = true;
      this.setPollGroup(group);
      this.setPollGroupId(group.pollGroupId);
      this.setAuthenticationMethods(group.authenticationMethods || {});
      this.nextPoll();
    },
    ...mapActions('pollGroup', [
      'nextPoll'
    ]),
    ...mapMutations('pollGroup', [
      'setPollGroup'
      ]),
    ...mapMutations('poll', [
      'setPollGroupId'
    ]),
    ...mapMutations('voter', [
      'setAuthenticationMethods'
    ])
  },
  async mounted() {
  },
  destroyed() {
    this.loading = false;
  }
}
</script>

<style scoped lang="scss">
section {
  min-width: 140px;
  z-index: 100;
  text-align: center;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  flex: 1 1 auto;
  width: 100%;

  > .v-align {
    display: table;
    margin: 0 auto;
    height: 100%;

    > .inner {
      display: table-cell;
      vertical-align: middle;
    }
  }
}

h2 {
  font-size: var(--question-fontsize);
  color: var(--question-color);
  transition: all 500ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
}

ul {
  padding-inline-start: 0;
}

.swpoll-vote {
  display: flex;
  align-items: center;
  position: relative;
  color: var(--answer-color);
  border: 1px solid #fff;
  transition: transform 900ms cubic-bezier(0.230, 1.000, 0.320, 1.000),
              box-shadow 350ms cubic-bezier(0.230, 1.000, 0.320, 1.000);
  border-radius: var(--answer-radius);
  padding: var(--answer-padding-ver) var(--answer-padding-hor);
  text-decoration: none !important;
  margin-bottom: var(--answer-bottommargin);
  margin-right: 1px;
  transition: .3s ease-out;
  transform: scale(1) translate3d(0,0,0);
  opacity: 1;
  backdrop-filter: blur(4px);
  min-height: var(--answer-min-height);
  cursor: pointer;
  background-color: var(--answer-bg);

  &:hover {
    .swimg {
      transform: scale(1.1);
      transition-delay: 0s;
    }
  }

  &.disabled {
    pointer-events: none;
  }

  p {
    margin: 0;
  }

  .text {
    padding-right: 50px;
    flex: 1 1 auto;
    position: relative;
    z-index: 1;
    opacity: 0;

    p {
      font-size: var(--answer-fontsize);
      font-weight: var(--answer-fontweight);

      span {
        display: inline;

        &.animateLetter {
          animation: letterPop ease-in-out .35s;
          animation-iteration-count: 1;
          animation-fill-mode: forwards;
          position: relative;
        }
      }
    }
  }

  .swimg {
    width: var(--answer-img-width);
    height: var(--answer-img-height);
    border-radius: var(--answer-img-radius);
    overflow: hidden;
    margin: -2px;
    margin-left: -10px;
    margin-right: 14px;
    flex: 0 0 auto;
    transition: all 2500ms cubic-bezier(0.22, 1, 0.36, 1);
    transform: scale(1);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &:hover {
    color: var(--answer-color);
    box-shadow: inset 0 0 0 var(--answer-borderwidth) transparent, 0 0 0 3px var(--answer-bordercolor);
  }

  &:focus {
    color: var(--answer-color);
  }
}

.option-list-enter-active {
  transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
}

.option-list-enter {
  opacity: 0;
  transform: scale(0.8);
}

.option-list-enter-to {
  opacity: 1;
  transform: scale(1);
}

@for $i from 0 through 10 {
  .option-list-enter-active:nth-child(#{$i}) {
    transition-delay: $i * 100ms + 600ms;
  }

  .button-#{$i}-enter-active {
    transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  .button-#{$i}-enter {
    opacity: 0;
    transform: scale(0.8);
  }

  .button-#{$i}-enter-to {
    opacity: 1;
    transform: scale(1);
  }

  .button-#{$i}-enter-active {
    transition-delay: ($i+1) * 100ms + 600ms;
  }
}

.fontLoaded {
  .text {
    opacity: 1;
  }
  .swpoll-vote {
    &.disabled {
      opacity: 0.5;
    }
  }
}

.preloader-enter-active, .preloader-leave-active {
  transition: all 750ms cubic-bezier(0.22, 1, 0.36, 1);
  transition-delay: 250ms;
}
.preloader-enter, .preloader-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>
